import { FC, useState } from 'react'
import { Button, Typography } from '@mui/material'
import { ProfileViewAlertContainer } from './ProfileViewAlertContainer'
import { ReconnectInstagramAccountDialog } from '~/components/common/Facebook/ReconnectInstagramAccountDialog'
import { DateTime } from 'luxon'

type Props = { nextTokenUpdateAt: string }

export const ReconnectAlert: FC<Props> = ({ nextTokenUpdateAt }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  return (
    <ProfileViewAlertContainer variant="warning">
      <Typography variant="body2">
        Instagramアカウントとの連携は3ヶ月に1度の更新が必要です。
        <br />
        引き続きレポート機能をご利用いただくには再連携が必要です。
        <br />
        <span style={{ fontWeight: 'bold' }}>{DateTime.fromISO(nextTokenUpdateAt).toFormat('yyyy/MM/dd')}</span>
        までに再連携を行ってください。
      </Typography>
      <Button onClick={handleOpen} size="small" variant="outlined" sx={{ mt: 2 }}>
        再連携
      </Button>

      <ReconnectInstagramAccountDialog isOpen={isOpen} onClose={handleClose} />
    </ProfileViewAlertContainer>
  )
}
